<div class="relative flex flex-col">
  <label for="search" class="sr-only">Address</label>
  <input #search type="text" name="search" id="search" placeholder="Address" autocomplete="off"
         class="rounded-full min-h-11 pl-8 pr-4 focus:outline-none lg:text-sm">
  <div class="absolute pointer-events-none left-2 top-1/2 -translate-y-1/2">
    <icon-location [size]="18" />
  </div>
</div>
